import { UnderwearOutlineIcon } from './UnderwearOutlineIcon';

/**
 * author: Jeff Anders
 * id 8A71EDC4-CA3C-450D-BD59-5915ADCDF9D4
 * name underwear-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/underwear-outline.svg
 * tags
 * - Clothing 
 */
export const BriefsOutlineIcon = UnderwearOutlineIcon;
export default BriefsOutlineIcon